module.exports = __webpack_public_path__ + "static/DS_wedding-3c876529ae1a0a289d8e8176397f5d5f.jpg";